import { Toaster } from "react-hot-toast";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import CnHome from "./CnHome";
import Home from "./Home";

const App = () => {
  return (
    <BrowserRouter>
      <Toaster position="bottom-center" reverseOrder={false} />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/cn" element={<CnHome />} />
      </Routes>
    </BrowserRouter>
  );
};

export default App;
